/**
 *
 * BLUEWALKER-3
 *
 */
const bw3TelemCategories = {
    "SOH": [
        "SBAND_GWD_COUNTER",
        "UHF_GS_WDT_COUNTER",
        "SOC_BATTERY1AND2_TOTAL_PERCENT",
        "PCDU_BATT_BFCP_XP",
        "ADCS_MODE",
        "SC_MODE",
        "AOCS_ACSUBMODE_ACTIVE",
        "GPS_FIX",
        // "AOCS_H_B_TOTAL",
        "AOCS_WBI_B_SV_ACTIVE_0_DEG",
        "AOCS_WBI_B_SV_ACTIVE_1_DEG",
        "AOCS_WBI_B_SV_ACTIVE_2_DEG",
        "AOCS_BETA_ANGLE_DEG",
        "AOCS_ORBIT_SEED_TIMER",
        "RWA_YM0_Z_MEASSPEED",
        "RWA_YM1_X_MEASSPEED",
        "RWA_YP0_Z_MEASSPEED",
        "RWA_YP1_X_MEASSPEED",
        "ROLL_DEG",
        "PITCH_DEG",
        "YAW_DEG",
    ],
    "COMM": [
        "SBAND_GWD_COUNTER",
        "BOOT_COUNT",
        "UHF_GS_WDT_COUNTER",
        "LVC_WDT_TIME_LEFT",
        "UHF_GS_WDT_TIME_LEFT_IN_SEC",
        "TIME_SINCE_LAST_COMM_IN_SEC",
        // "QVA_YP_STATUS_CURRENT_STATE",
        "QVA_YM_STATUS_CURRENT_STATE",
    ],
    "AOCS": [
        "ADCS_MODE",
        "SC_MODE",
        "AOCS_ACSUBMODE_ACTIVE",
        // "AOCS_H_B_TOTAL",
        // "AOCS_TH_B_ERROR_0_DEG",
        // "AOCS_TH_B_ERROR_1_DEG",
        // "AOCS_TH_B_ERROR_2_DEG",
        "AOCS_TH_B_ERROR_0",
        "AOCS_TH_B_ERROR_1",
        "AOCS_TH_B_ERROR_2",
        // "AOCS_WBI_B_SV_ACTIVE_0_DEG",
        // "AOCS_WBI_B_SV_ACTIVE_1_DEG",
        // "AOCS_WBI_B_SV_ACTIVE_2_DEG",
        "AOCS_WBI_B_SV_ACTIVE_0",
        "AOCS_WBI_B_SV_ACTIVE_1",
        "AOCS_WBI_B_SV_ACTIVE_2",
        "RWA_YM0_Z_MEASSPEED",
        "RWA_YM1_X_MEASSPEED",
        "RWA_YP0_Z_MEASSPEED",
        "RWA_YP1_X_MEASSPEED",
        "ROLL_DEG",
        "PITCH_DEG",
        "YAW_DEG",
        "GPS_FIX",
        "GPS_x0",
        "GPS_x1",
        "GPS_x2",
        "GPS_v0",
        "GPS_v1",
        "GPS_v2",
        "GPS_TIME_SEC",
        "AOCS_ECLIPSEFLAG",
        "AOCS_BETA_ANGLE_DEG",
        "ST_MODE_XM",
        "ST_MODE_XP",
    ],
    "THRML": [
        "APC_BOARD_TEMP",
        "FC_BOARD_TEMP",
        "GPS_BOARD_TEMP",
        "AGG1_BOARD_TEMP",
        "AGG2_BOARD_TEMP",
        "PCDU_BATT_ADC_THERM1",
        "PCDU_BATT_ADC_THERM2",
        "PCDU_BATT_ADC_THERM3",
        "PCDU_BATT_ADC_THERM4",
        "PCDU_MICRON_ADC_THERM1",
        "PCDU_MICRON_ADC_THERM2",
        "PCDU_MPPT_SWITCH_ADC_THERM1",
        "PCDU_MPPT_SWITCH_ADC_THERM2",
    ],
    "EPS": [
        "SOC_BATTERY1AND2_TOTAL",
        "SOC_BATTERY1AND2_TOTAL_PERCENT",
        "SOC_BATTERY1_VOLTAGE_MEDIAN",
        "SOC_BATTERY2_VOLTAGE_MEDIAN",
        "PCDU_BATT_BFCP_XP",
        "PCDU_BATT_BFCP_XM",
    ],
    "MICRON PM": ["*MICRON_[0-9]{1,3}_POWER_MODE"],
    "MICRON SoC": ["*MICRON_[0-9]{1,3}_SOC"],
    "OPEN TICKETS": [],
    "FDIR SUMMARY": [],
};

/**
 *
 * BLOCK 1 (SM001-005)
 *
 */
const block1TelemCategories = {
    "SOH": [
        "SBAND_GWD_COUNTER",
        "UHF_GS_WDT_COUNTER",
        "SOC_BATTERY1AND2_TOTAL_PERCENT",
        "PCDU_BATT_BFCP_XP",
        "SC_MODE",
        "AOCS_ACMODE_ACTIVE",
        "AOCS_ACSUBMODE_ACTIVE",
        "GPS_FIX",
        // "AOCS_H_B_TOTAL",
        "AOCS_WBI_B_SV_ACTIVE_0_DEG",
        "AOCS_WBI_B_SV_ACTIVE_1_DEG",
        "AOCS_WBI_B_SV_ACTIVE_2_DEG",
        "AOCS_WBI_B_SV_ACTIVE_0_DEG_S",
        "AOCS_WBI_B_SV_ACTIVE_1_DEG_S",
        "AOCS_WBI_B_SV_ACTIVE_2_DEG_S",
        "AOCS_BETA_ANGLE_DEG",
        "AOCS_ORBIT_SEED_TIMER",
        "RWA_YM0_Z_MEASSPEED",
        "RWA_YM1_X_MEASSPEED",
        "RWA_YP0_Z_MEASSPEED",
        "RWA_YP1_X_MEASSPEED",

        "MEDIC_STACK_LOCATION",
        "MEDIC_STACK_STATE",

        "ROLL_DEG",
        "PITCH_DEG",
        "YAW_DEG",
    ],
    "COMM": [
        "SBAND_GWD_COUNTER",
        "BOOT_COUNT",
        "UHF_GS_WDT_COUNTER",
        "LVC_WDT_TIME_LEFT",
        "UHF_GS_WDT_TIME_LEFT_IN_SEC",
        "TIME_SINCE_LAST_COMM_IN_SEC",
        // "QVA_YP_STATUS_CURRENT_STATE",
        "QVA_YM_STATUS_CURRENT_STATE",
    ],
    "AOCS": [
        "SC_MODE",
        "AOCS_ACMODE_ACTIVE",
        "AOCS_ACSUBMODE_ACTIVE",
        // "AOCS_H_B_TOTAL",
        // "AOCS_TH_B_ERROR_0_DEG",
        // "AOCS_TH_B_ERROR_1_DEG",
        // "AOCS_TH_B_ERROR_2_DEG",
        "AOCS_TH_B_ERROR_0",
        "AOCS_TH_B_ERROR_1",
        "AOCS_TH_B_ERROR_2",
        // "AOCS_WBI_B_SV_ACTIVE_0_DEG",
        // "AOCS_WBI_B_SV_ACTIVE_1_DEG",
        // "AOCS_WBI_B_SV_ACTIVE_2_DEG",
        "AOCS_WBI_B_SV_ACTIVE_0",
        "AOCS_WBI_B_SV_ACTIVE_1",
        "AOCS_WBI_B_SV_ACTIVE_2",
        "RWA_YM0_Z_MEASSPEED",
        "RWA_YM1_X_MEASSPEED",
        "RWA_YP0_Z_MEASSPEED",
        "RWA_YP1_X_MEASSPEED",
        "ROLL_DEG",
        "PITCH_DEG",
        "YAW_DEG",
        "GPS_YM_FIX",
        "GPS_YP_FIX",
        "GPS_x0",
        "GPS_x1",
        "GPS_x2",
        "GPS_v0",
        "GPS_v1",
        "GPS_v2",
        "GPS_TIME_SEC",
        "AOCS_ECLIPSEFLAG",
        "AOCS_BETA_ANGLE_DEG",
        "ST_MODE_XM",
        "ST_MODE_XP",
    ],
    "THRML": [
        "APC_BOARD_TEMP",
        "FC_BOARD_TEMP",
        "GPS_BOARD_TEMP",
        "AGG1_BOARD_TEMP",
        "AGG2_BOARD_TEMP",
        "PCDU_BATT_ADC_THERM1_SIDE_A",
        "PCDU_BATT_ADC_THERM1_SIDE_B",
        "PCDU_BATT_ADC_THERM2_SIDE_A",
        "PCDU_BATT_ADC_THERM2_SIDE_B",
        "PCDU_BATT_ADC_THERM3_SIDE_A",
        "PCDU_BATT_ADC_THERM3_SIDE_B",
        "PCDU_BATT_ADC_THERM4_SIDE_A",
        "PCDU_BATT_ADC_THERM4_SIDE_B",
        "PCDU_MICRON_ADC_THERM1_SIDE_A",
        "PCDU_MICRON_ADC_THERM1_SIDE_B",
        "PCDU_MICRON_ADC_THERM2_SIDE_A",
        "PCDU_MICRON_ADC_THERM2_SIDE_B",
        "PCDU_MPPT_SWITCH_ADC_THERM1_SIDE_A",
        "PCDU_MPPT_SWITCH_ADC_THERM1_SIDE_B",
        "PCDU_MPPT_SWITCH_ADC_THERM2_SIDE_A",
        "PCDU_MPPT_SWITCH_ADC_THERM2_SIDE_B",
    ],
    "EPS": [
        "SOC_BATTERY1AND2_TOTAL",
        "SOC_BATTERY1AND2_TOTAL_PERCENT",
        "SOC_BATTERY1_VOLTAGE_MEDIAN",
        "SOC_BATTERY2_VOLTAGE_MEDIAN",
        "PCDU_BATT_BFCP_XP",
        "PCDU_BATT_BFCP_XM",
    ],
    "MICRON PM": ["*MICRON_[0-9]{1,3}_POWER_MODE"],
    "MICRON SoC": ["*MICRON_[0-9]{1,3}_SOC"],
    "OPEN TICKETS": [],
    "FDIR SUMMARY": [],
};

/**
 *
 * BLOCK 2 (SM006-?)
 *
 */
const block2TelemCategories = {
    "SOH": [
        "SBAND_WATCHDOG_TIMER_IN_SEC",
        "UHF_WATCHDOG_TIMER_IN_SEC",

        "ESS_SIDE_A_TOTAL_SOC",
        "ESS_SIDE_B_TOTAL_SOC",

        // "SC_MODE",
        "AOCS_ACMODE_ACTIVE",
        "AOCS_ACSUBMODE_ACTIVE",

        "AOCS_BETA_ANGLE_DEG",
        "AOCS_ORBIT_SEED_TIMER",

        "RWA_01_SPEED_MEAS_RPM",
        "RWA_02_SPEED_MEAS_RPM",
        "RWA_03_SPEED_MEAS_RPM",
        "RWA_04_SPEED_MEAS_RPM",
        "RWA_05_SPEED_MEAS_RPM",
        "RWA_06_SPEED_MEAS_RPM",
        "RWA_07_SPEED_MEAS_RPM",
        "RWA_08_SPEED_MEAS_RPM",
        "RWA_09_SPEED_MEAS_RPM",
        "RWA_10_SPEED_MEAS_RPM",
        "RWA_11_SPEED_MEAS_RPM",
        "RWA_12_SPEED_MEAS_RPM",

        "MEDIC_STACK_LOCATION",
        "MEDIC_STACK_STATE",

        "ROLL_DEG",
        "PITCH_DEG",
        "YAW_DEG",
    ],
    "COMM": [
        "SBAND_WATCHDOG_TIMER_IN_SEC",
        "UHF_WATCHDOG_TIMER_IN_SEC",
        "LVC_WATCHDOG_TIMER_IN_SEC",
    ],
    "AOCS": [
        "SC_MODE",
        "AOCS_ACMODE_ACTIVE",
        "AOCS_ACSUBMODE_ACTIVE",

        "AOCS_BETA_ANGLE_DEG",
        "AOCS_ORBIT_SEED_TIMER",

        "RWA_01_SPEED_MEAS_RPM",
        "RWA_02_SPEED_MEAS_RPM",
        "RWA_03_SPEED_MEAS_RPM",
        "RWA_04_SPEED_MEAS_RPM",
        "RWA_05_SPEED_MEAS_RPM",
        "RWA_06_SPEED_MEAS_RPM",
        "RWA_07_SPEED_MEAS_RPM",
        "RWA_08_SPEED_MEAS_RPM",
        "RWA_09_SPEED_MEAS_RPM",
        "RWA_10_SPEED_MEAS_RPM",
        "RWA_11_SPEED_MEAS_RPM",
        "RWA_12_SPEED_MEAS_RPM",

        "ROLL_DEG",
        "PITCH_DEG",
        "YAW_DEG",
    ],
    "THRML": [
        "AOCS_BOARD_TEMP_C",
        "APC_BOARD_TEMP_C",
        "CP_BOARD_TEMP_C",
        "DPC_BOARD_TEMP_C",
        "GNC_BOARD_TEMP_C",
        "GPS_BOARD_TEMP_C",
    ],
    "EPS": [
        "ESS_SIDE_A_TOTAL_SOC",
        "ESS_SIDE_B_TOTAL_SOC",
    ],
    "MICRON PM": ["*MICRON_[0-9]{1,3}_POWER_MODE"],
    "MICRON SoC": ["*MICRON_[0-9]{1,3}_SOC"],
    "OPEN TICKETS": [],
    "FDIR SUMMARY": [],
};

export const getSatConfig = (satellite) => {
    if (!satellite) return null;

    // const key = satellite.norad_id; // used to be norad_id
    const key = satellite.sat_id; // used to be norad_id
    if (key === "BW3" || key?.toUpperCase() === "BLUEWALKER-3") {
        return {
            sat_name: "BlueWalker-3",
            sat_id: "sbw3",
            telemetryCategories: bw3TelemCategories,
            block: 0,
        };
    }

    if (!key.startsWith("SM")) return null;

    const smNum = Number.parseInt(key.slice(2));
    if (Number.isNaN(smNum)) return null;

    const isBB2 = smNum >= 6; // SM001-SM005 are block 1, SM006 and above are block 2

    return {
        sat_name: key,
        sat_id: key,
        telemetryCategories: isBB2 ? block2TelemCategories : block1TelemCategories,
        block: isBB2 ? 2 : 1,
    };
};
